import { useEffect, useState } from "react";
import { useFormatTemplateStore } from "@/state/formatTemplateStore";
import UserEmailTagsInputField from "@/components/ui/UserEmailTagsInputField";
import Ring from "@/components/ui/Ring";

export default function EditApprovalSection() {
  const [editApprovals, setApprovals] = useState([]);
  const { setEditApprovals } = useFormatTemplateStore();
  useEffect(() => {
    const { editApprovals: editApproval } = useFormatTemplateStore.getState();
    setApprovals(editApproval);
  }, []);
  return (
    <Ring className="p-4 mt-10 flex flex-col gap-8">
      <p>The following individuals will be able to edit the Format Template once created:</p>
      <div className={"w-4/5"}>
        <UserEmailTagsInputField
          placeholder="Enter Emails"
          initialTags={editApprovals}
          onChange={(tags: any) => setEditApprovals(tags)}
        />
      </div>
    </Ring>
  );
}
